'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationFareBuilderService = function ConfigurationFareBuilderService(restangular, $q, $http, cityToPosMapper, fileSaveService, $rootScope) {
  var updateBulkFareBuilderService = restangular.service('external').one('faresoptimizer').one('fareBuilder').one('bulk');
  function save(editedRows) {
    var rowsForDeletion = [];
    _.forEach(editedRows, function (editedRow) {
      if (_.has(editedRow, '_old') && !_.has(editedRow, 'isNewlyAdded')) {
        rowsForDeletion.push(buildPayLoadForRemovalWhileSaving(editedRow));
      }
    });
    var deletePromises = [];
    if (!_.isEmpty(rowsForDeletion)) {
      deletePromises.push(deleteFromServer(rowsForDeletion));
      $q.all(deletePromises).then(new Promise(function (resolve) {
        return setTimeout(resolve, 0);
      }));
    }
    var payloads = buildSavePayloads(editedRows);
    var promises = [];
    if (payloads && payloads.length) {
      promises.push(saveToServer(payloads));
    }
    return $q.all(promises).then(new Promise(function (resolve) {
      return setTimeout(resolve, 0);
    }));
  }
  function buildSavePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  function remove(rows) {
    var payloads = buildRemovePayloads(rows);
    return $q.all(deleteFromServer(payloads));
  }
  function buildRemovePayloads(rows) {
    var existingData = $rootScope.gridData;
    var finalReducedData = _.reduce(rows, function (result, row) {
      var toBeDeletedKeys = uniqueSetCreation(row, false);
      toBeDeletedKeys.forEach(function (key) {
        if (existingData.has(key)) {
          existingData["delete"](key);
        }
      });
      result.push(buildPayload(row));
      return result;
    }, []);
    $rootScope.gridData = existingData;
    return finalReducedData;
  }
  function editCountryField(cityList) {
    var newCountries = [];
    var originList = _.split(cityList, ',');
    _.forEach(originList, function (city) {
      if (city.length === 3) {
        newCountries.push(cityToPosMapper.getCountry(city));
      } else {
        newCountries.push(city);
      }
    });
    return _.join(_.uniq(newCountries), ',');
  }
  function getStringValue(value) {
    return _.isNil(value) || _.isEmpty(value) ? null : value;
  }
  function getDateStringValue(value) {
    return _.isNil(value) || _.isEmpty(value) ? null : value.toISOString();
  }
  function buildPayLoadForRemovalWhileSaving(row) {
    return {
      hostCarrier: _.has(row._old, 'hostCarrier') ? getStringValue(row._old.hostCarrier) : getStringValue(row.hostCarrier),
      tariffCode: _.has(row._old, 'tariffCode') ? getStringValue(row._old.tariffCode) : getStringValue(row.tariffCode),
      sponsorFareRule: _.has(row._old, 'sponsorFareRule') ? getStringValue(row._old.sponsorFareRule) : getStringValue(row.sponsorFareRule),
      targetFareRule: _.has(row._old, 'targetFareRule') ? getStringValue(row._old.targetFareRule) : getStringValue(row.targetFareRule),
      origin: _.has(row._old, 'foOrigin') ? getStringValue(row._old.foOrigin) : getStringValue(row.foOrigin),
      originCountry: _.has(row._old, 'foOriginCountry') ? getStringValue(row._old.foOriginCountry) : getStringValue(row.foOriginCountry),
      destination: _.has(row._old, 'foDestination') ? getStringValue(row._old.foDestination) : getStringValue(row.foDestination),
      destinationCountry: _.has(row._old, 'foDestinationCountry') ? getStringValue(row._old.foDestinationCountry) : getStringValue(row.foDestinationCountry),
      sponsorFareTripType: _.has(row._old, 'sponsorFareTripType') ? getStringValue(row._old.sponsorFareTripType) : getStringValue(row.sponsorFareTripType),
      targetFareTripType: _.has(row._old, 'targetFareTripType') ? getStringValue(row._old.targetFareTripType) : getStringValue(row.targetFareTripType),
      sponsorFareBrand: _.has(row._old, 'sponsorFareBrand') ? getStringValue(row._old.sponsorFareBrand) : getStringValue(row.sponsorFareBrand),
      targetFareBrand: _.has(row._old, 'targetFareBrand') ? getStringValue(row._old.targetFareBrand) : getStringValue(row.targetFareBrand),
      sponsorFareRBD: _.has(row._old, 'sponsorFareRBD') ? getStringValue(row._old.sponsorFareRBD) : getStringValue(row.sponsorFareRBD),
      targetFareRBD: _.has(row._old, 'targetFareRBD') ? getStringValue(row._old.targetFareRBD) : getStringValue(row.targetFareRBD),
      sponsorFareFamily: _.has(row._old, 'sponsorFareFamily') ? getStringValue(row._old.sponsorFareFamily) : getStringValue(row.sponsorFareFamily),
      targetFBC: _.has(row._old, 'targetFBC') ? getStringValue(row._old.targetFBC) : getStringValue(row.targetFBC),
      rbdTableNumber: _.has(row._old, 'rbdTableNumber') ? row._old.rbdTableNumber : row.rbdTableNumber,
      targetFareCalculationType: _.has(row._old, 'targetFareCalculationType') ? getStringValue(row._old.targetFareCalculationType) : getStringValue(row.targetFareCalculationType),
      targetFareCalculationPercentage: _.has(row._old, 'targetFareCalculationPercentage') ? row._old.targetFareCalculationPercentage : row.targetFareCalculationPercentage,
      targetFareCalculationAmount: _.has(row._old, 'targetFareCalculationAmount') ? row._old.targetFareCalculationAmount : row.targetFareCalculationAmount,
      minimumGapCondition: _.has(row._old, 'minimumGapCondition') ? getStringValue(row._old.minimumGapCondition) : getStringValue(row.minimumGapCondition),
      minimumGapValue: _.has(row._old, 'minimumGapValue') ? row._old.minimumGapValue : row.minimumGapValue,
      notes: _.has(row._old, 'notes') ? getStringValue(row._old.notes) : getStringValue(row.notes)
    };
  }
  function buildPayload(row) {
    return {
      hostCarrier: _.isNil(row.hostCarrier) || row.hostCarrier === '' ? null : row.hostCarrier,
      tariffCode: _.isNil(row.tariffCode) || row.tariffCode === '' ? null : row.tariffCode,
      sponsorFareRule: _.isNil(row.sponsorFareRule) || row.sponsorFareRule === '' ? null : row.sponsorFareRule,
      targetFareRule: _.isNil(row.targetFareRule) || row.targetFareRule === '' ? null : row.targetFareRule,
      origin: _.isNil(row.foOrigin) || row.foOrigin === '' ? null : row.foOrigin,
      originCountry: _.has(row._old, 'foOrigin') ? editCountryField(row.foOrigin) : row.foOriginCountry,
      destination: _.isNil(row.foDestination) || row.foDestination === '' ? null : row.foDestination,
      destinationCountry: _.has(row._old, 'foDestination') ? editCountryField(row.foDestination) : row.foDestinationCountry,
      sponsorFareTripType: _.isNil(row.sponsorFareTripType) || row.sponsorFareTripType === '' ? null : row.sponsorFareTripType,
      targetFareTripType: _.isNil(row.targetFareTripType) || row.targetFareTripType === '' ? null : row.targetFareTripType,
      sponsorFareBrand: _.isNil(row.sponsorFareBrand) || row.sponsorFareBrand === '' ? null : row.sponsorFareBrand,
      targetFareBrand: _.isNil(row.targetFareBrand) || row.targetFareBrand === '' ? null : row.targetFareBrand,
      sponsorFareRBD: _.isNil(row.sponsorFareRBD) || row.sponsorFareRBD === '' ? null : row.sponsorFareRBD,
      targetFareRBD: _.isNil(row.targetFareRBD) || row.targetFareRBD === '' ? null : row.targetFareRBD,
      sponsorFareFamily: _.isNil(row.sponsorFareFamily) || row.sponsorFareFamily === '' ? null : row.sponsorFareFamily,
      targetFBC: _.isNil(row.targetFBC) || row.targetFBC === '' ? null : row.targetFBC,
      rbdTableNumber: row.rbdTableNumber,
      targetFareCalculationType: _.isNil(row.targetFareCalculationType) || row.targetFareCalculationType === '' ? null : row.targetFareCalculationType,
      targetFareCalculationPercentage: row.targetFareCalculationPercentage,
      targetFareCalculationAmount: row.targetFareCalculationAmount,
      minimumGapCondition: _.isNil(row.minimumGapCondition) || row.minimumGapCondition === '' ? null : row.minimumGapCondition,
      minimumGapValue: row.minimumGapValue,
      notes: _.isNil(row.notes) || row.notes === '' ? null : row.notes
    };
  }
  function deleteFromServer(payloads) {
    return _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/faresoptimizer/fareBuilder',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
  }
  function saveToServer(payloads) {
    return updateBulkFareBuilderService.customPUT({
      value: payloads
    });
  }
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvHeader() {
    return formatAsCsvRow(['Host Carrier', 'Tariff', 'Sponsor Fare Rule', 'Target Fare Rule', 'Origin', 'Origin Country', 'Destination', 'Destination Country', 'Sponsor Fare Trip Type', 'Target Fare Trip Type', 'Sponsor Fare Brand', 'Target Fare Brand', 'Sponsor Fare RBD', 'Target Fare RBD', 'Sponsor Fare Family', 'Target Fare Basis Pattern', 'RBD Table Number', 'Target Fare Calculation Type', 'Target Fare Calculation Percentage', 'Target Fare Calculation Amount', 'Minimum Gap Condition', 'Minimum Gap Value', 'Notes']);
  }
  function createCsvRow(row) {
    return formatAsCsvRow([_.isNil(row.hostCarrier) ? '' : '\"' + row.hostCarrier.toUpperCase() + '\"', _.isNil(row.tariffCode) ? '' : row.tariffCode.toUpperCase(), _.isNil(row.sponsorFareRule) ? '' : row.sponsorFareRule.toUpperCase(), _.isNil(row.targetFareRule) ? '' : row.targetFareRule.toUpperCase(), _.isNil(row.foOrigin) ? '' : '\"' + row.foOrigin.toUpperCase() + '\"', _.isNil(row.foOriginCountry) ? '' : '\"' + row.foOriginCountry.toUpperCase() + '\"', _.isNil(row.foDestination) ? '' : '\"' + row.foDestination.toUpperCase() + '\"', _.isNil(row.foDestinationCountry) ? '' : '\"' + row.foDestinationCountry.toUpperCase() + '\"', _.isNil(row.sponsorFareTripType) ? '' : '\"' + row.sponsorFareTripType.toUpperCase() + '\"', _.isNil(row.targetFareTripType) ? '' : '\"' + row.targetFareTripType.toUpperCase() + '\"', _.isNil(row.sponsorFareBrand) ? '' : row.sponsorFareBrand.toUpperCase(), _.isNil(row.targetFareBrand) ? '' : row.targetFareBrand.toUpperCase(), _.isNil(row.sponsorFareRBD) ? '' : row.sponsorFareRBD.toUpperCase(), _.isNil(row.targetFareRBD) ? '' : row.targetFareRBD.toUpperCase(), _.isNil(row.sponsorFareFamily) ? '' : row.sponsorFareFamily.toUpperCase(), _.isNil(row.targetFBC) ? '' : row.targetFBC.toUpperCase(), row.rbdTableNumber, _.isNil(row.targetFareCalculationType) ? '' : row.targetFareCalculationType.toUpperCase(), row.targetFareCalculationPercentage, row.targetFareCalculationAmount, _.isNil(row.minimumGapCondition) ? '' : row.minimumGapCondition.toUpperCase(), row.minimumGapValue, _.isNil(row.notes) ? '' : '\"' + row.notes + '\"']);
  }
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'FOFareBuilder.csv');
  }
  function validateStringField(rowProperty, field, valid) {
    if (valid && _.isEmpty(rowProperty)) {
      toastr.error(field + ' must not be empty');
      valid = false;
    }
    return valid;
  }
  function validateNumericField(rowProperty, field, valid) {
    if (valid && _.isNil(rowProperty)) {
      toastr.error(field + ' must not be empty');
      valid = false;
    }
    return valid;
  }
  function validateFields(editedRow, valid) {
    if (valid && (_.isEqual(editedRow.targetFareCalculationType, 'A') || _.isEqual(editedRow.targetFareCalculationType, 'BOTH')) && _.isNil(editedRow.targetFareCalculationAmount)) {
      toastr.error('According to the Target Fare Calculation Type Selection, the Target Fare Calculation Amount should be populated');
      valid = false;
    }
    if (valid && (_.isEqual(editedRow.targetFareCalculationType, 'P') || _.isEqual(editedRow.targetFareCalculationType, 'BOTH')) && _.isNil(editedRow.targetFareCalculationPercentage)) {
      toastr.error('According to the Target Fare Calculation Type Selection, the Target Fare Calculation Percentage should be populated');
      valid = false;
    }
    if (valid && (_.isEqual(editedRow.targetFareCalculationType, 'P') || _.isEqual(editedRow.targetFareCalculationType, 'BOTH')) && !_.isNil(editedRow.targetFareCalculationPercentage) && editedRow.targetFareCalculationPercentage < 0) {
      toastr.error('Target Fare Calculation Percentage should be non-negative');
      valid = false;
    }
    if (valid && (_.isEqual(editedRow.minimumGapCondition, 'A') || _.isEqual(editedRow.minimumGapCondition, 'P')) && _.isNil(editedRow.minimumGapValue)) {
      toastr.error('According to the Minimum Gap Condition Selection, the Minimum Gap Value should be populated');
      valid = false;
    }
    if (valid && _.isEqual(editedRow.minimumGapCondition, 'P') && !_.isNil(editedRow.minimumGapValue) && editedRow.minimumGapValue < 0) {
      toastr.error('Minimum Gap Value Percentage should be non negative');
      valid = false;
    }
    if (valid && _.isEqual(_.split(editedRow.origin, ',').length, 1) && _.isEqual(_.split(editedRow.destination, ',').length, 1) && _.isEqual(editedRow.origin.length, 3) && _.isEqual(editedRow.destination.length, 3) && _.isEqual(editedRow.origin, editedRow.destination)) {
      toastr.error('Origin and Destination cannot be the same POS');
      valid = false;
    }
    if (_.isEqual(getString(editedRow.sponsorFareRBD), '') && _.isEqual(getString(editedRow.sponsorFareFamily), '')) {
      toastr.error('If Sponsor Fare RBD is not Populated, Sponsor Fare Family must be entered and vice versa');
      valid = false;
    }
    return valid;
  }
  function getString(value) {
    return _.isNil(value) || _.isEmpty(value) ? '' : value;
  }
  function uniqueSetCreation(row, isNewRow) {
    var uniqueKeys = new Set();
    var hostCarrierList;
    var originList;
    var destinationList;
    var sponsorFareTripTypeList;
    var commonKey;
    var key;
    if (isNewRow) {
      hostCarrierList = _.has(row, 'hostCarrier') ? _.split(getString(row.hostCarrier), ',') : [];
      originList = _.split(getString(row.foOrigin), ',');
      destinationList = _.split(getString(row.foDestination), ',');
      sponsorFareTripTypeList = _.has(row, 'sponsorFareTripType') ? _.split(getString(row.sponsorFareTripType), ',') : [];
      commonKey = getString(row.tariffCode) + '-' + getString(row.sponsorFareRule) + '-' + getString(row.sponsorFareBrand) + '-' + getString(row.targetFareBrand) + '-' + getString(row.sponsorFareRBD) + '-' + getString(row.targetFareRBD) + '-' + getString(row.sponsorFareFamily) + '-' + getString(row.targetFBC) + '-' + getString(row.targetFareTripType) + '-';
    } else {
      hostCarrierList = _.has(row._old, 'hostCarrier') ? _.split(getString(row._old.hostCarrier), ',') : _.split(getString(row.hostCarrier), ',');
      originList = _.has(row._old, 'foOrigin') ? _.split(getString(row._old.foOrigin), ',') : _.split(getString(row.foOrigin), ',');
      destinationList = _.has(row._old, 'foDestination') ? _.split(getString(row._old.foDestination), ',') : _.split(getString(row.foDestination), ',');
      sponsorFareTripTypeList = _.has(row._old, 'sponsorFareTripType') ? _.split(getString(row._old.sponsorFareTripType), ',') : _.split(getString(row.sponsorFareTripType), ',');
      var targetFareTripType = _.has(row._old, 'targetFareTripType') ? getString(row._old.targetFareTripType) : getString(row.targetFareTripType);
      var tariffCode = _.has(row._old, 'tariffCode') ? getString(row._old.tariffCode) : getString(row.tariffCode);
      var sponsorFareRule = _.has(row._old, 'sponsorFareRule') ? getString(row._old.sponsorFareRule) : getString(row.sponsorFareRule);
      var sponsorFareBrand = _.has(row._old, 'sponsorFareBrand') ? getString(row._old.sponsorFareBrand) : getString(row.sponsorFareBrand);
      var targetFareBrand = _.has(row._old, 'targetFareBrand') ? getString(row._old.targetFareBrand) : getString(row.targetFareBrand);
      var sponsorFareRBD = _.has(row._old, 'sponsorFareRBD') ? getString(row._old.sponsorFareRBD) : getString(row.sponsorFareRBD);
      var targetFareRBD = _.has(row._old, 'targetFareRBD') ? getString(row._old.targetFareRBD) : getString(row.targetFareRBD);
      var sponsorFareFamily = _.has(row._old, 'sponsorFareFamily') ? getString(row._old.sponsorFareFamily) : getString(row.sponsorFareFamily);
      var targetFBC = _.has(row._old, 'targetFBC') ? getString(row._old.targetFBC) : getString(row.targetFBC);
      commonKey = tariffCode + '-' + sponsorFareRule + '-' + sponsorFareBrand + '-' + targetFareBrand + '-' + sponsorFareRBD + '-' + targetFareRBD + '-' + sponsorFareFamily + '-' + targetFBC + '-' + targetFareTripType + '-';
    }
    for (var i = 0; i < hostCarrierList.length; i++) {
      for (var j = 0; j < originList.length; j++) {
        for (var k = 0; k < destinationList.length; k++) {
          if (sponsorFareTripTypeList.length === 0) {
            key = getString(hostCarrierList[i]) + '-' + commonKey + getString(originList[j]) + '-' + getString(destinationList[k]);
            uniqueKeys.add(key);
          } else {
            for (var l = 0; l < sponsorFareTripTypeList.length; l++) {
              key = getString(hostCarrierList[i]) + '-' + commonKey + getString(originList[j]) + '-' + getString(destinationList[k]) + '-' + getString(sponsorFareTripTypeList[l]);
              uniqueKeys.add(key);
            }
          }
        }
      }
    }
    return uniqueKeys;
  }
  function duplicateRowsIdentified(gridData, editedRow, previousEditedRow, existingKeys) {
    var isDuplicate = false;
    var newKeys = uniqueSetCreation(editedRow, true);
    if (!_.isNil(previousEditedRow)) {
      var previousKeys = uniqueSetCreation(previousEditedRow, true);
      if (_.isEqual(previousKeys, newKeys)) {
        isDuplicate = true;
      }
    }
    if (isDuplicate) {
      return true;
    }
    if (_.has(editedRow, 'isNewlyAdded')) {
      newKeys.forEach(function (key) {
        if (existingKeys.has(key)) {
          isDuplicate = true;
        }
      });
    } else {
      var toBeRemovedKeys = uniqueSetCreation(editedRow, false);
      if (_.has(editedRow._old, 'hostCarrier') && !_.isEqual(editedRow.hostCarrier, editedRow._old.hostCarrier) || _.has(editedRow._old, 'foOrigin') && !_.isEqual(editedRow.foOrigin, editedRow._old.foOrigin) || _.has(editedRow._old, 'foDestination') && !_.isEqual(editedRow.foDestination, editedRow._old.foDestination) || _.has(editedRow._old, 'tariffCode') && !_.isEqual(editedRow.tariffCode, editedRow._old.tariffCode) || _.has(editedRow._old, 'sponsorFareRule') && !_.isEqual(editedRow.sponsorFareRule, editedRow._old.sponsorFareRule) || _.has(editedRow._old, 'sponsorFareTripType') && !_.isEqual(editedRow.sponsorFareTripType, editedRow._old.sponsorFareTripType) || _.has(editedRow._old, 'targetFareTripType') && !_.isEqual(editedRow.targetFareTripType, editedRow._old.targetFareTripType) || _.has(editedRow._old, 'sponsorFareBrand') && !_.isEqual(editedRow.sponsorFareBrand, editedRow._old.sponsorFareBrand) || _.has(editedRow._old, 'targetFareBrand') && !_.isEqual(editedRow.targetFareBrand, editedRow._old.targetFareBrand) || _.has(editedRow._old, 'sponsorFareRBD') && !_.isEqual(editedRow.sponsorFareRBD, editedRow._old.sponsorFareRBD) || _.has(editedRow._old, 'targetFareRBD') && !_.isEqual(editedRow.targetFareRBD, editedRow._old.targetFareRBD) || _.has(editedRow._old, 'sponsorFareFamily') && !_.isEqual(editedRow.sponsorFareFamily, editedRow._old.sponsorFareFamily) || _.has(editedRow._old, 'targetFBC') && !_.isEqual(editedRow.targetFBC, editedRow._old.targetFBC)) {
        newKeys.forEach(function (key) {
          if (existingKeys.has(key) && !toBeRemovedKeys.has(key)) {
            isDuplicate = true;
          }
        });
      }
      if (!isDuplicate) {
        toBeRemovedKeys.forEach(function (key) {
          return existingKeys["delete"](key);
        });
      }
    }
    if (isDuplicate) {
      return true;
    }
    newKeys.forEach(function (key) {
      return existingKeys.add(key);
    });
    return false;
  }
  function areRowsValid(editedRows, gridData) {
    var valid = true;
    var previousEditedRow;
    var existingKeys = _.cloneDeep($rootScope.gridData);
    for (var i = 0, editedRowsLength = editedRows.length; i < editedRowsLength; i++) {
      var editedRow = editedRows[i];
      editedRow.origin = editedRow.foOrigin;
      editedRow.destination = editedRow.foDestination;
      valid = validateStringField(editedRow.origin, 'Origin', valid);
      valid = validateStringField(editedRow.destination, 'Destination', valid);
      valid = validateStringField(editedRow.targetFareRBD, 'Target Fare RBD', valid);
      valid = validateNumericField(editedRow.rbdTableNumber, 'RBD Table No', valid);
      valid = validateStringField(editedRow.targetFareCalculationType, 'Target Fare Calculation Type', valid);
      valid = validateStringField(editedRow.targetFBC, 'Target Fare Basis Pattern', valid);
      valid = validateFields(editedRow, valid);
      if (valid) {
        if (duplicateRowsIdentified(gridData, editedRow, previousEditedRow, existingKeys)) {
          valid = false;
        }
        previousEditedRow = editedRow;
        if (!valid) {
          toastr.error('Duplicate rows identified');
          break;
        }
      }
      if (!valid) {
        return false;
      }
    }
    if (valid) {
      $rootScope.gridData = existingKeys;
    }
    return valid;
  }
  function validate(editedRows, gridData) {
    var filteredData = _.reject(gridData, {
      'isNewlyAdded': true
    });
    return areRowsValid(editedRows, filteredData);
  }
  return {
    save: save,
    remove: remove,
    exportToCsv: exportToCsv,
    validate: validate
  };
};
ConfigurationFareBuilderService.$inject = ['Restangular', '$q', '$http', 'CityToPosMapper', 'FileSaveService', '$rootScope'];
module.exports = ConfigurationFareBuilderService;